import { Type } from 'class-transformer';
import { IsArray, IsString, ValidateNested } from 'class-validator';

/**
 * Envelope of `GET /self-check-attachments/by-sources`. The attachment shape is a
 * type parameter: the backend fills it with its own response DTO (dates as `Date`),
 * the frontend reads it with its JSON type (dates as ISO strings).
 */
export class SelfCheckAttachmentsForSourceDto<TAttachment = unknown> {
  @IsString()
  sourceId!: string;

  @IsArray()
  attachments!: TAttachment[];
}

/** One entry per requested record, in request order; `attachments` is empty when none are linked. */
export class SelfCheckAttachmentsBySourcesResponseDto<TAttachment = unknown> {
  @ValidateNested({ each: true })
  @Type(() => SelfCheckAttachmentsForSourceDto)
  attachmentsBySourceId!: SelfCheckAttachmentsForSourceDto<TAttachment>[];
}
